import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import axios from 'axios';
import { environment } from '../../environments/environment';
import { getAuth, confirmPasswordReset } from 'firebase/auth';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.css'
})
export class ResetPasswordComponent implements OnInit {
  resetForm: FormGroup;
  errorMessage = '';
  successMessage = '';
  loading = false;
  oobCode: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.resetForm = new FormGroup({
      password: new FormControl('', [Validators.required, Validators.minLength(6)]),
      confirmPassword: new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    // Get the oobCode from URL parameters
    this.route.queryParams.subscribe(params => {
      this.oobCode = params['oobCode'];
      if (!this.oobCode) {
        this.errorMessage = 'Invalid password reset link';
      }
    });
  }

  async onSubmit() {
    if (this.resetForm.valid && this.oobCode) {
      const password = this.resetForm.get('password')?.value;
      const confirmPassword = this.resetForm.get('confirmPassword')?.value;

      if (password !== confirmPassword) {
        this.errorMessage = 'Passwords do not match';
        return;
      }

      this.loading = true;
      this.errorMessage = '';
      this.successMessage = '';

      try {
        // Use Firebase client SDK to confirm password reset
        
        
        const auth = getAuth();
        confirmPasswordReset(auth, this.oobCode, password)
          .then(() => {
            this.successMessage = 'Password has been reset successfully';
            // Redirect to login after 2 seconds
            setTimeout(() => {
              this.router.navigate(['/login']);
            }, 2000);
          })
          .catch(error => {
            throw error;
          });
      } catch (error: any) {
        console.error('Error resetting password:', error);
        this.errorMessage = error.message || 'An error occurred while resetting password';
      } finally {
        this.loading = false;
      }
    }
  }

  // Dark mode support
  isDarkMode(): boolean {
    return document.documentElement.classList.contains('dark');
  }
} 